// material-ui
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const MenuIcon = ({ iconFill }) => {
    const theme = useTheme();

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
        <svg width="28" height="22" viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M26.3547 17.9959C25.3466 17.8609 24.3808 17.4052 23.64 16.7075C22.9789 16.083 22.0365 16.0717 21.3801 16.7075C19.6031 18.4179 16.3539 18.4179 14.5488 16.6231C13.9158 15.9929 13.0015 16.1111 12.3592 16.7244C10.5775 18.4179 7.34705 18.4123 5.55131 16.6287C4.91835 15.9986 3.99001 16.128 3.34298 16.7413C2.61624 17.4277 1.65508 17.8721 0.637651 18.0015C0.267251 18.0466 0 18.4404 0 18.8849V20.6966C0 21.2086 0.356334 21.6418 0.782998 21.5968C2.13332 21.4561 3.41331 20.9554 4.50575 20.1396C7.15482 22.0863 10.9292 22.0581 13.5079 20.1396C16.157 22.0863 19.9313 22.0581 22.51 20.1396C23.6025 20.9385 24.8965 21.4505 26.2187 21.5912C26.6454 21.6362 27.0017 21.2029 27.0017 20.6909V18.913C27.0064 18.4629 26.7345 18.0466 26.3547 17.9959ZM26.3547 9.894C25.3466 9.75897 24.3808 9.30324 23.64 8.60557C22.9789 7.98105 22.0365 7.9698 21.3801 8.60557C19.6031 10.316 16.3539 10.316 14.5488 8.52118C13.9158 7.89103 13.0015 8.00918 12.3592 8.62245C10.5775 10.316 7.34705 10.3104 5.55131 8.5268C4.91835 7.89665 3.99001 8.02606 3.34298 8.63933C2.61624 9.32574 1.65508 9.77022 0.637651 9.89963C0.267251 9.94464 0 10.3385 0 10.783V12.5946C0 13.1066 0.356334 13.5399 0.782998 13.4949C2.13332 13.3542 3.41331 12.8535 4.50575 12.0376C7.15482 13.9843 10.9292 13.9562 13.5079 12.0376C16.157 13.9843 19.9313 13.9562 22.51 12.0376C23.6025 12.8366 24.8965 13.3486 26.2187 13.4892C26.6454 13.5342 27.0017 13.101 27.0017 12.589V10.8111C27.0064 10.361 26.7345 9.94464 26.3547 9.894ZM26.3547 1.79208C25.3466 1.65142 24.3808 1.20131 23.64 0.503649C22.9789 -0.120874 22.0365 -0.132127 21.3801 0.503649C19.6031 2.21405 16.3539 2.21405 14.5488 0.419254C13.9158 -0.210895 13.0015 -0.0927421 12.3592 0.520528C10.5775 2.21406 7.34705 2.20843 5.55131 0.42488C4.91835 -0.205269 3.99001 -0.0758634 3.34298 0.537407C2.61624 1.22382 1.65508 1.6683 0.637651 1.79771C0.267251 1.84272 0 2.23656 0 2.68104V4.49272C0 5.00472 0.356334 5.43794 0.782998 5.39293C2.13332 5.25227 3.41331 4.75153 4.50575 3.93571C7.15482 5.88242 10.9292 5.85429 13.5079 3.93571C16.157 5.88242 19.9313 5.85429 22.51 3.93571C23.6025 4.73465 24.8965 5.24665 26.2187 5.38731C26.6454 5.43232 27.0017 4.99909 27.0017 4.48709V2.70917C27.0064 2.25907 26.7345 1.84272 26.3547 1.79208Z"
                fill={iconFill}
            />
        </svg>
    );
};

MenuIcon.propTypes = {
    iconFill: PropTypes.string
};

export default MenuIcon;
